/**
 * №29 (S2) — THE INTAKE SUBJECT (mockup C: "a matter is born from the conversation").
 *
 * The probe's only TWO-ZONE mockup. There is no work rail, because nothing is running
 * yet and there is no crew working-state to sit beside the conversation — the whole
 * stage is the conversation, and what it produces is a DRAFT record you can accept.
 *
 * S0 implemented the geometry (`rail: "none"`, honoured by the shell, proven at the
 * narrow breakpoint) but routed nothing at it. This is the route, and it is what makes
 * the probe's `New…` nav row a live destination rather than the dead one the S0
 * findings deliberately left out.
 *
 * ## What is HERE, and what is honestly not
 *
 * Here: the two-zone geometry, the intake conversation on the stage, and an anchor
 * that is the workspace — because a record that does not exist yet cannot be anchored
 * on, and pretending otherwise is the №22.3.2 F1 defect (a surface whose declared
 * context and applied context differ).
 *
 * **NOT here: the draft record card.** Mockup C's payoff is a *proposal* — a matter,
 * a fee basis, a key date and a five-step workflow rendered from one sentence, with
 * "nothing saved yet" on it and three buttons under it. That needs an engine verb
 * that PROPOSES without writing, and then commits on the human's press. Kuvio's
 * shipped create verbs (`create_matter`, `create_contact`, …) write immediately, so
 * drawing that card today would mean either a frame with nothing behind it or a
 * "draft" that is actually a saved record — and mockup C's whole caption is *"nothing
 * is saved until you press the button, so the draft record is a proposal, not a side
 * effect."*
 *
 * That propose-then-commit contract is a birth-path question (D-L3: two paths, one of
 * them refusable by policy), not a shell question. It is named in the S2 findings as
 * an open decision with its own owner rather than half-built here. The shell's share
 * of mockup C — the geometry, the route, the nav row — is what this file is.
 */
import { useConversationSlot } from "../../components/collab/conversation-host";

export function IntakeSubjectPage() {
  const stageSlot = useConversationSlot("stage");
  // No `useStageHead` here on purpose: the matrix row's chip is already "New", so a
  // declared title would render "New / New". The head falls back to naming the
  // SUBJECT, which is the one thing left worth saying about this surface.
  return (
    <div className="chatstage chatstage--intake" data-testid="intake-stage">
      <div ref={stageSlot} className="chatstage__slot" />
    </div>
  );
}
